import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions, REDUCER_KEY } from './reducer';
import DoohPublishersActions from 'states/resources/doohPublishers/actions';

export function useAdSummary() {
    const dispatch = useDispatch();
    const state = useSelector(state => state[REDUCER_KEY]);
    const boundActions = bindActionCreators(actions, dispatch);
    const getAllDoohPublishers = bindActionCreators(DoohPublishersActions.getAll, dispatch);

    return {
        ...state,
        ...boundActions,
        getAllDoohPublishers: getAllDoohPublishers,
    };
}
